const ConnexusLabels = {
  PASSWORD_STRENGTH_TEXT: 'PASSWORD_STRENGTH_TEXT',
  PASSWORD_STRENGTH_BAD: 'PASSWORD_STRENGTH_BAD',
  PASSWORD_STRENGTH_WEAK: 'PASSWORD_STRENGTH_WEAK',
  PASSWORD_STRENGTH_OKAY: 'PASSWORD_STRENGTH_OKAY',
  PASSWORD_STRENGTH_GOOD: 'PASSWORD_STRENGTH_GOOD',
  CLEAR: 'CLEAR',
  MSG_ERROR: 'MSG_ERROR',
}

export default ConnexusLabels
